module.exports = __webpack_public_path__ + "static/media/italian5000.f99711ff.png";